import React from 'react';

interface ScrollOffsetLinkProps {
    offset: number
    href: string
    className?: string
    children: React.ReactNode
}

const ScrollOffsetLink: React.FC<ScrollOffsetLinkProps> = ({ offset, href, className, children }) => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        const id = href.replace('#', '');
        const element = document.getElementById(id);

        if (element) {
            const yOffset = offset;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });

            // Update the URL hash without causing a jump
            window.history.pushState(null, '', href);
        }
    };

    return (
        <a href={href} className={className} onClick={handleClick}>
            {children}
        </a>
    );
};

export default ScrollOffsetLink;
